export default "__VITE_ASSET__CbbnNuen__"